// Cache keys

export const SCHEDULE_CACHE_KEY = 'SCHEDULE';
